module.exports = __webpack_public_path__ + "img/noinfo.cd9a2acc.png";